module.exports = "<n-way-confirmation-modal data=\"$ctrl\"></n-way-confirmation-modal>\n"